<ng-content></ng-content>
<button *ngIf="dismissible" type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onClose()">
    <app-icon name="cross-12" size="12"></app-icon>
</button>
